export default __webpack_public_path__ + "static/6_lighten-f23ecebe28e91f60fa86329b28b1ad63.png";